export default __webpack_public_path__ + "img/fXwYEEUA.b570febe.svg";